import { useCallback, useState } from "react";

import { Toastify } from "./Toastify";

const TOASTIFY_DELAY = 2000;

export function Copyable({ children, value, msg = "Address copied!" }) {
    const [toastMsg, setToastMsg] = useState("");
    const copyAddress = useCallback(async () => {
        if (value) {
            await navigator.clipboard.writeText(value);
            setToastMsg(msg);
        }
    }, [value, msg]);

    return (
        <div title={value} className="inline-flex items-center justify-start">
            {children}
            <div
                className="ml-1 cursor-pointer hover:drop-shadow"
                onClick={copyAddress}
            >
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.2203 14H8.22034C7.6899 14 7.1812 13.7893 6.80612 13.4142C6.43105 13.0391 6.22034 12.5304 6.22034 12V8C6.22034 7.46957 6.43105 6.96086 6.80612 6.58579C7.1812 6.21071 7.6899 6 8.22034 6H12.2203C12.7508 6 13.2595 6.21071 13.6346 6.58579C14.0096 6.96086 14.2203 7.46957 14.2203 8V12C14.2203 12.5304 14.0096 13.0391 13.6346 13.4142C13.2595 13.7893 12.7508 14 12.2203 14ZM8.22034 7.33333C8.04353 7.33333 7.87396 7.40357 7.74893 7.5286C7.62391 7.65362 7.55367 7.82319 7.55367 8V12C7.55367 12.1768 7.62391 12.3464 7.74893 12.4714C7.87396 12.5964 8.04353 12.6667 8.22034 12.6667H12.2203C12.3971 12.6667 12.5667 12.5964 12.6917 12.4714C12.8168 12.3464 12.887 12.1768 12.887 12V8C12.887 7.82319 12.8168 7.65362 12.6917 7.5286C12.5667 7.40357 12.3971 7.33333 12.2203 7.33333H8.22034Z"
                        fill="#78706F"
                    />
                    <path
                        d="M6.707 10H4.00034C3.52879 9.99824 3.07706 9.81014 2.74363 9.47671C2.41019 9.14328 2.22209 8.69155 2.22034 8.22V3.78C2.22209 3.30846 2.41019 2.85672 2.74363 2.52329C3.07706 2.18986 3.52879 2.00176 4.00034 2H8.44034C8.91188 2.00176 9.36361 2.18986 9.69705 2.52329C10.0305 2.85672 10.2186 3.30846 10.2203 3.78V6.26667H8.887V3.78C8.887 3.66154 8.83994 3.54793 8.75618 3.46416C8.67241 3.38039 8.5588 3.33333 8.44034 3.33333H4.00034C3.88187 3.33333 3.76826 3.38039 3.6845 3.46416C3.60073 3.54793 3.55367 3.66154 3.55367 3.78V8.22C3.55367 8.33846 3.60073 8.45208 3.6845 8.53584C3.76826 8.61961 3.88187 8.66667 4.00034 8.66667H6.707V10Z"
                        fill="#78706F"
                    />
                </svg>
            </div>
            <Toastify
                content={toastMsg}
                duration={TOASTIFY_DELAY}
                setToastMsg={setToastMsg}
            />
        </div>
    );
}
